export default function SET_SITE_MODERATOR_WORKFLOW(state) {
  state.siteModerators.proposed = [];
}
